import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getAllCodesOfPractice = api(async function allCodesOfPractice() {
    return query(
        gql`
            query GetAllCodesOfPractice {
                allCodesOfPractice
            }
        `,
        {},
        { returns: "allCodesOfPractice" }
    )
})
